import Model from '@ember-data/model';
import DS from 'ember-data';
import attr from 'ember-data/attr';
import { hasMany } from 'ember-data/relationships';

import CampaignModel from 'cio/models/campaign';
import NewsletterModel from 'cio/models/newsletter';

export default class MessageLimitModel extends Model {
  @attr('number') count!: number;
  @attr('number') windowSecs!: number;
  @attr('number') retryWindowSecs!: number;

  @hasMany('campaign', { async: true, inverse: null }) campaignsEnabled!: DS.PromiseManyArray<CampaignModel>;
  @attr() campaignsEnabledMessageCounts!: Record<string, number>;

  @hasMany('newsletter', { async: true, inverse: null }) newslettersEnabled!: DS.PromiseManyArray<NewsletterModel>;
  @attr() newslettersEnabledMessageCounts!: Record<string, number>;

  @hasMany('campaign', { async: true, inverse: null }) apiTbsEnabled!: DS.PromiseManyArray<CampaignModel>;
  @attr() apiTbsEnabledMessageCounts!: Record<string, number>;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'message-limit': MessageLimitModel;
  }
}
